export const formatRupiah = (val) => {
    const n = Number(val || 0);
    return "Rp " + n.toLocaleString("id-ID", { maximumFractionDigits: 0 });
};

export const formatTanggal = (isoStr) => {
    if (!isoStr) return "-";
    try {
        const d = new Date(isoStr);
        const dd = String(d.getDate()).padStart(2, "0");
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const yyyy = d.getFullYear();
        return `${dd}/${mm}/${yyyy}`;
    } catch {
        return "-";
    }
};

export const formatTanggalPanjang = (isoStr = new Date().toISOString()) => {
    const bulan = [
        "Januari", "Februari", "Maret", "April", "Mei", "Juni",
        "Juli", "Agustus", "September", "Oktober", "November", "Desember",
    ];
    const hari = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
    const d = new Date(isoStr);
    return `${hari[d.getDay()]}, ${d.getDate()} ${bulan[d.getMonth()]} ${d.getFullYear()}`;
};

export const roleLabel = (role) => {
    switch (role) {
        // Role baru v1.3.0
        case "owner": return "Owner";
        case "accounting": return "Accounting";
        // Legacy role (kompat)
        case "admin": return "Administrator";
        case "staf_input": return "Staf Input";
        case "staf_cek": return "Staf Cek";
        default: return role || "-";
    }
};

export const roleBadgeClass = (role) => {
    switch (role) {
        case "owner": return "bg-blue-50 text-blue-700 border-blue-200";
        case "accounting": return "bg-slate-100 text-slate-700 border-slate-200";
        // Legacy
        case "admin": return "bg-blue-50 text-blue-700 border-blue-200";
        case "staf_input": return "bg-slate-100 text-slate-700 border-slate-200";
        case "staf_cek": return "bg-slate-100 text-slate-700 border-slate-200";
        default: return "bg-slate-50 text-slate-700 border-slate-200";
    }
};
